module.exports = {"TXTWCL_Request_successful":{"id":"TXTWCL_Request_successful","defaultMessage":"Zahtjev je uspješno obrađen"}}